import React from "react";
import { MessageCircle } from "lucide-react";
import { trackEvent, EVENTS } from "@/utils/tracking";
import { getWhatsAppLink } from "@/utils/links";

export default function WhatsAppFab() {
  return (
    <a
      href={getWhatsAppLink()}
      target="_blank"
      rel="noreferrer noopener"
      data-testid="whatsapp-fab"
      aria-label="Chat on WhatsApp"
      onClick={() => trackEvent(EVENTS.WHATSAPP_CLICK, { location: "floating-fab" })}
      className="fixed bottom-6 right-6 z-40 inline-flex items-center gap-3 pl-4 pr-5 py-3.5 rounded-full bg-[#25D366] text-white shadow-[0_18px_40px_-16px_rgba(37,211,102,0.7)] hover:scale-105 transition-transform"
    >
      <MessageCircle size={18} />
      <span className="text-[12px] tracking-[0.18em] uppercase font-medium hidden sm:inline">WhatsApp</span>
    </a>
  );
}
